module.exports = __webpack_public_path__ + "img/Android1.76bba60c.png";